import clsx from 'clsx';
import React from 'react';

import { download_project_csv_path } from '@routes';

import { PowerlistPersonData, PowerlistPersonDetails } from '..';
import PowerlistRow from './Row';
import styles from './styles.module.scss';

const SECTION_NAMES = ['executives', 'investors', 'emerging'];

interface PowerlistSectionProps {
  corpOrGroupSubscriber?: boolean;
  details: PowerlistPersonDetails;
  handleClose: () => void;
  handlePersonClick: (person: PowerlistPersonData, rowNum: string) => void;
  section: PowerlistPersonData[];
  sectionNum: number;
  title: string;
}

const PowerlistSection = ({
  corpOrGroupSubscriber = false,
  details,
  handleClose,
  handlePersonClick,
  section,
  sectionNum,
  title,
}: PowerlistSectionProps) => {
  // info used to download csv
  const pathArr = window.location.pathname.split('/');
  const projectName = pathArr[pathArr.length - 1];

  return (
    <div className="col-sm-10 col-sm-offset-1 mt2">
      <div className="title-container">
        <div className="section-title">{title}</div>
        <div className={styles.titleUnderline}></div>
      </div>
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(0, 3)}
        rowNum={`${sectionNum}.1`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(3, 5)}
        rowNum={`${sectionNum}.2`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(5, 8)}
        rowNum={`${sectionNum}.3`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(8)}
        rowNum={`${sectionNum}.4`}
      />
      {sectionNum === 3 && (
        <div
          className={`reference-row ${corpOrGroupSubscriber ? 'justify-between' : 'justify-end'}`}
        >
          {corpOrGroupSubscriber && (
            <div className="flex flex-col">
              {SECTION_NAMES.map((sectionName) => (
                <a
                  key={sectionName}
                  className="text-body-sm !text-primary-magenta hover:!text-primary-magenta"
                  href={download_project_csv_path(projectName, {
                    sheet_name: sectionName,
                    sheet_range: '!A1:AL',
                  })}
                >
                  Download {sectionName === 'emerging' ? 'up & comers' : sectionName} csv
                </a>
              ))}
            </div>
          )}
          <div className={clsx(styles.referenceNotes, 'reference-notes')}>
            Data are of Aug 8, 2022. Interactive by Haejin Park, Mack Cooper and Mike Sullivan.
            {'\n'}
            Typography by Justin Bihan via VTF
          </div>
        </div>
      )}
    </div>
  );
};

export default PowerlistSection;
